/** @jsxImportSource @emotion/react */

import { LinkDownloadFileApk } from "constants/apk";
import { arrayProvider } from "constants/provider";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { FooterStyle } from "./index.style";

const Footer = () => {
  const { t } = useTranslation("footer");
  return (
    <>
      <div css={FooterStyle.container}>
        <div css={FooterStyle.footerLeft}>
          <div css={FooterStyle.groupBox}>
            <h3>Ed3333</h3>
            <Link target="_blank" to={LinkDownloadFileApk}>
              {t("DownloadAPP")}
            </Link>
            <Link to={"#"}>{t("About")}</Link>
          </div>
          <div style={{ marginTop: "16px" }} css={FooterStyle.groupBox}>
            <h3>{t("TermsPolicies")}</h3>
            <Link to={"#"}>{t("Antimoneylaunderingpolicy")}</Link>
            <Link to={"/privacy"}>{t("PrivacyPolicy")}</Link>
            <Link to={"#"}>{t("UserAgreement")}</Link>
            <Link to={"#"}>{t("TermsofService")}</Link>
          </div>
        </div>
        <div css={FooterStyle.footerRight}>
          <div css={FooterStyle.provider}>
            <h3>{t("Provider")}</h3>
            <div className="list-provider">
              {arrayProvider.map((item, index) => {
                return (
                  <Link
                    key={`provider-item-${index}`}
                    to={item.link}
                    className="item-provider"
                  >
                    <img src={item.icon} alt="" />
                  </Link>
                );
              })}
            </div>
          </div>
        </div>
        <div css={FooterStyle.copyRight}>
          <h3>{t("COPYRIGHT")}</h3>
        </div>
      </div>
    </>
  );
};

export default Footer;
